import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store'
import { UserProfileState, userProfileStoreKey } from './user-profile.state'
import { User } from '../../models/user'
import { UserItem } from '../../models/user-item'

const getError = (state: UserProfileState): any => {
  return state ? state.error : 'no state'
}
// state ? state.error ? state.error : 'state=null' : 'state.error=null';
const getIsLoading = (state: UserProfileState): boolean => state.isInLogin
const getUser = (state: UserProfileState): User => state.user
const isLoggedIn = (state: UserProfileState): any => !!state?.user?.token
const getInnerUser = (state: UserProfileState): UserItem => state?.user?.user
const getIsInLogout = (state: UserProfileState): boolean => state?.isInLogout

const getEnforcePwChange = (state: UserProfileState): boolean => {
  return state?.user?.user?.enforcePasswdChange
}

const getValidUntil = (state: UserProfileState): string => state?.user?.validUntil

const getDefaultDashboardHrid = (state: UserProfileState): string => state?.user?.defaultDashboardHrid

const tokenIsValidated = (state: UserProfileState): any => !!state.tokenIsValidated
const getDefaultStartRoute = (state: UserProfileState): string => state?.user?.defaultStartRoute

export const selectUserProfileState: MemoizedSelector<object, UserProfileState> =
  createFeatureSelector<UserProfileState>(userProfileStoreKey)
export const selectUserProfileError: MemoizedSelector<object, any> = createSelector(selectUserProfileState, getError)
export const selectUserProfileIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectUserProfileState,
  getIsLoading
)
export const selectUserProfileUser: MemoizedSelector<object, User> = createSelector(selectUserProfileState, getUser)
export const selectIsLoggedIn: MemoizedSelector<object, boolean> = createSelector(selectUserProfileState, isLoggedIn)
export const selectTokenIsValidated: MemoizedSelector<object, boolean> = createSelector(
  selectUserProfileState,
  tokenIsValidated
)
export const selectUserProfileInnerUser: MemoizedSelector<object, UserItem> = createSelector(
  selectUserProfileState,
  getInnerUser
)
export const selectEnforcePwChange: MemoizedSelector<object, boolean> = createSelector(
  selectUserProfileState,
  getEnforcePwChange
)
export const selectValidUntil: MemoizedSelector<object, string> = createSelector(selectUserProfileState, getValidUntil)
export const selectDefaultDashboardHrid: MemoizedSelector<object, string> = createSelector(
  selectUserProfileState,
  getDefaultDashboardHrid
)
export const selectUserIsInLogout: MemoizedSelector<object, boolean> = createSelector(
  selectUserProfileState,
  getIsInLogout
)
export const selectDefaultStartRoute: MemoizedSelector<object, string> = createSelector(
  selectUserProfileState,
  getDefaultStartRoute
)
